export default __webpack_public_path__ + "static/media/Ziqi.ed6d5b18.jpg";